import { lazy } from 'react'
import { Route } from 'commons/types/route'
import { LOGIN_ROUTE, LOGOUT_ROUTE } from 'commons/constants/app'

const AuthLoginPage = lazy(() => import('pages/Auth/Login'))
const AuthLogoutPage = lazy(() => import('pages/Auth/Logout'))

export default [
  {
    path: LOGIN_ROUTE,
    component: AuthLoginPage,
    hasLayout: false,
    isPublic: true,
  },
  {
    path: LOGOUT_ROUTE,
    component: AuthLogoutPage,
    hasLayout: false,
    isPublic: true,
  },
] as Route[]
